import React from "react";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import NavDropdown from "react-bootstrap/NavDropdown";

import logo from "../img/towa_logo4.png";

import layoutStyles from "./header.module.css";

import { routeHostByPref } from "./footer";

const Header = function ({ property }) {
  return (
    <header className="fixed-top" style={{ borderBottom: "1px solid #ffcc00" }}>
      <Navbar
        expand="lg"
        className="pt-1 pl-0 pr-0 pb-0 align-items-start"
        style={{ backgroundColor: "#343a40" }}
      >
        <div
          className="p-2 d-flex flex-wrap flex-grow-1 justify-content-between"
          style={{ backgroundColor: "#343a40" }}
        >
          <Navbar.Brand
            href={`${routeHostByPref(property.pref) + "house/home.html"}`}
          >
            <img
              src={logo}
              alt="千葉の藤和ハウジング 住宅取扱い"
              loading="lazy"
            />
          </Navbar.Brand>
          <Navbar.Toggle
            aria-controls="navbarSupportedContent"
            className={`bg-white ${layoutStyles.togglerIconCustom}`}
          />

          <Navbar.Collapse
            id="navbarSupportedContent"
            className={`justify-content-end`}
          >
            <Nav style={{ fontSize: "1rem" }}>
              <NavDropdown
                className={`${layoutStyles.dropdownCustom} mx-2`}
                title={
                  <span style={{ color: "cornsilk", fontWeight: "bold" }}>
                    住宅取扱い
                  </span>
                }
                id="nav-dropdown"
              >
                <NavDropdown.Item
                  href={`${routeHostByPref(property.pref) + "house/sell.html"}`}
                >
                  買取かんたん査定
                </NavDropdown.Item>
                <NavDropdown.Item
                  href={`${routeHostByPref(property.pref) + "house/used-list"}`}
                >
                  中古物件
                </NavDropdown.Item>
                <NavDropdown.Item
                  href={`${
                    routeHostByPref(property.pref) + "house/rental-list"
                  }`}
                >
                  賃貸物件
                </NavDropdown.Item>
              </NavDropdown>

              <Nav.Link
                href={`${routeHostByPref(property.pref) + "/"}`}
                className="mx-2 nav-link font-weight-bold"
                style={{ color: "cornsilk", fontWeight: "bold" }}
              >
                屋根工事・外壁塗装・内装
              </Nav.Link>

              <Nav.Item>
                <Nav.Link
                  href={`${routeHostByPref(property.pref) + "company"}`}
                  className="mx-2 nav-link font-weight-bold"
                  style={{ color: "cornsilk", fontWeight: "bold" }}
                >
                  会社情報
                </Nav.Link>
              </Nav.Item>
            </Nav>
          </Navbar.Collapse>
        </div>

        <div className={`mt-1 mx-1 ${layoutStyles.call}`}>
          <p
            style={{ fontSize: "0.7rem", verticalAlign: "text-top" }}
            className="mb-0"
          >
            お問い合わせ
          </p>
          <i
            className={`${layoutStyles.materialIcons}`}
            style={{ verticalAlign: "sub", fontSize: "1rem" }}
          >
            call
          </i>
          <span style={{ fontSize: "1rem" }}>043-497-4500</span>
        </div>
      </Navbar>
    </header>
  );
};

export default Header;
